import { isGateWallet, switchNetworkInGate } from './gateWalletHelper'

export interface EIP1193Provider {
  request: (args: { method: string; params?: unknown[] | object }) => Promise<unknown>
}

const TARGET_CHAIN_ID = parseInt(process.env.REACT_APP_CHAIN_ID ?? '10323')
const TARGET_CHAIN_HEX = `0x${TARGET_CHAIN_ID.toString(16)}`
const TARGET_RPC_URL = process.env.REACT_APP_NETWORK_URL || ''
const TARGET_CHAIN_SYMBOL = 'MARS'
const TARGET_CHAIN_NAME = 'Mova Beta'
const TARGET_EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL || ''

export async function switchOrAddNetwork(provider?: EIP1193Provider | null) {
  const p: EIP1193Provider | undefined =
    provider || (typeof window !== 'undefined' ? ((window as any).ethereum as EIP1193Provider) : undefined)
  if (!p || typeof p.request !== 'function') return

  // 检查是否是 Gate dApp
  if (isGateWallet()) {
    console.log('Detected Gate dApp, using special handling...')
    const success = await switchNetworkInGate(TARGET_CHAIN_ID)
    if (success) return
  }

  // 方法1: 尝试标准方法切换网络
  try {
    await p.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: TARGET_CHAIN_HEX }]
    })
    return // 成功切换，直接返回
  } catch (switchError) {
    const code = (switchError as any)?.code ?? (switchError as any)?.data?.originalError?.code
    if (code === 4902) {
      // 网络未添加，尝试添加
      try {
        await p.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: TARGET_CHAIN_HEX,
              chainName: TARGET_CHAIN_NAME,
              nativeCurrency: { name: TARGET_CHAIN_SYMBOL, symbol: TARGET_CHAIN_SYMBOL, decimals: 18 },
              rpcUrls: TARGET_RPC_URL ? [TARGET_RPC_URL] : [],
              blockExplorerUrls: TARGET_EXPLORER_URL ? [TARGET_EXPLORER_URL] : []
            }
          ]
        })
        return // 成功添加，直接返回
      } catch (addError) {
        console.warn('Failed to add network:', addError)
      }
    } else {
      console.warn('Failed to switch network:', switchError)
    }
  }

  // 方法2: 尝试旧版方法 (某些钱包可能支持)
  try {
    if ((p as any).send) {
      await (p as any).send('wallet_addEthereumChain', [
        {
          chainId: TARGET_CHAIN_HEX,
          chainName: TARGET_CHAIN_NAME,
          nativeCurrency: { name: TARGET_CHAIN_SYMBOL, symbol: TARGET_CHAIN_SYMBOL, decimals: 18 },
          rpcUrls: TARGET_RPC_URL ? [TARGET_RPC_URL] : [],
          blockExplorerUrls: TARGET_EXPLORER_URL ? [TARGET_EXPLORER_URL] : []
        }
      ])
      return
    }
  } catch (error) {
    console.warn('Legacy method failed:', error)
  }

  // 方法3: 尝试直接设置网络 (Gate dApp 等可能支持)
  try {
    if ((p as any).setNetwork) {
      await (p as any).setNetwork(TARGET_CHAIN_ID)
      return
    }
  } catch (error) {
    console.warn('setNetwork method failed:', error)
  }

  // 方法4: 尝试通过 window.ethereum 直接操作
  if (typeof window !== 'undefined' && (window as any).ethereum) {
    try {
      // 某些钱包可能支持直接设置 chainId
      if ((window as any).ethereum.chainId !== TARGET_CHAIN_HEX) {
        // 尝试触发网络切换事件
        const event = new CustomEvent('chainChanged', { detail: TARGET_CHAIN_HEX })
        window.dispatchEvent(event)
      }
    } catch (error) {
      console.warn('Custom network change failed:', error)
    }
  }

  console.warn('All network switching methods failed. User may need to manually switch networks.')
}
